// Shared pluraliser for credit counts used across every project cost summary.
const getCreditsLabel = (cost) => cost > 1 ? 'Credits' : 'Credit';

export default getCreditsLabel;
